import { config, $_app_server, $_app_server_noAuth } from '@/_helpers'
import axios from "axios"
import { $_user_role as Role } from '@/common/UserUtils'

export const userService = {
  login,
  oneLogin,
  logout,
  logoutJudge,
  confirm,
  existRole,
  hasRole,

  userList,
  grantList,
  userAdd,
  userUpdate,
  addGrant,
  changePassword,
  getUserAuth,
  getCourtAlias,

  extOauth,
  refreshToken
}

function login (username, password) {
  let security = new FormData();
  security.append("grant_type", 'password')
  security.append("username", username)
  security.append("password", password)

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
  
  return axios.post(config.authUrl, security, { headers })
  .then(response => {
    let { access_token, refresh_token,  grants, useruuid, fio } = response.data
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('refresh_token', refresh_token)
    localStorage.setItem('grants', grants)
    localStorage.setItem('useruuid', useruuid.replace(/"/gi, ''))
    localStorage.setItem('fio', fio.replace(/"/gi, ''))

    let grants_json = JSON.parse(grants)
    let roles = grants_json.map(item => item.grantType).join(',')
    localStorage.setItem('roles', roles)

    if (getCourtAlias()=='') {
       let gr = grants_json.filter(item => item.grantType == Role.judge)
       if (gr.length > 0) 
          localStorage.setItem('courtAlias', gr[0].location)
    }

    $_app_server.defaults.headers.common.Authorization = 'Bearer ' + access_token
    // $_app_server.interceptors.response.use(response => response, errorHandler)
    return true
  })
  .catch(error => {
    if (error.response.status === 401) {
      logout()
      location.reload()
      return false
    }
  })
}

function oneLogin (password) {
  return axios.get(config.oneAuthUrl+password)
  .then(response => response.data)
  .catch(error => {
    if (error.response.status === 401) {
      logout()
      location.reload(true)
      return false
    }
  })
}

function logout() {
  $_app_server.defaults.headers.common.Authorization = null
  let LoginName = localStorage.getItem("LoginName")
  if (LoginName) {
    localStorage.clear()
    localStorage.setItem("LoginName", LoginName)
  }

  location.href="/"
//  location.reload(true)
}

function logoutJudge(textError) {
  // Вывод ошибки если судья не найден
  localStorage.setItem('error', textError)
  logout()
}

function confirm (uid, code) {
  return axios.get(config.confirmUrl+'/'+uid+'/'+code)
  .then(response => {
    if (response.data.status == 'error')
       return false
    else 
       return true
  })
  .catch(error => {
    console.log(error)
    return false
  })
}

function existRole(grant) {
    return hasRole([grant])
}

function hasRole(roles) {
    let myRoles = localStorage.getItem('roles').split(',') || []
    for (let index = 0; index < myRoles.length; index++) {
      const aRole = myRoles[index]
      if (roles.includes(aRole)) return true
    }
    return false
}

function userList () {
  return $_app_server.get('/users/' + getCourtAlias()).then(response => response.data)
}

function grantList () {
  return $_app_server.get('/grants/' + getCourtAlias()).then(response => response.data)
}

function userAdd (obj) {
  return $_app_server.put('users/add/' + getCourtAlias(), obj).then(response => response.data)
}

function userUpdate (obj) {
  return $_app_server.put('users/update/' + getCourtAlias(), obj).then(response => response.data)
}

function addGrant (obj, action) {
  return $_app_server.put('users/grant/' + getCourtAlias() + '/' + action, obj).then(response => response.data)
}

function changePassword (obj) {
  return $_app_server.put('users/change/' + getCourtAlias(), obj).then(response => response.data)
}

function getUserAuth () {
  return $_app_server.get('authuser').then(response => response.data)
}

function getCourtAlias () {
  return localStorage.getItem("courtAlias")
}

function refreshToken () {
  let security = new FormData();
  security.append("grant_type", 'refresh_token')
  security.append("refresh_token", localStorage.getItem("refresh_token"))

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
  
  return axios.post(config.authUrl, security, { headers })
  .then(response => {
    let { access_token, refresh_token } = response.data
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('refresh_token', refresh_token)
  })
}

function extOauth(source, type) {
  return auth('oauth/extoauth/' + type, source, { })
}

function auth(url, params, headers) {
  return $_app_server_noAuth.post(url, params, headers)
    .then(({ data }) => {
      authUse(data)
      $_app_server.defaults.headers.common.Authorization = 'Bearer ' + data.access_token
      return true
    })
    .catch(error => {
      if (error.response.status === 401) {
        logout()
        location.reload()
        return false
      }
    })
}

function  authUse (data = {}) {
    let { access_token, grants, fio, refresh_token } = data
    localStorage.setItem('access_token', access_token)
    
    localStorage.setItem('refresh_token', refresh_token)
    localStorage.setItem('grants', grants)
    localStorage.setItem('fio', fio.replace(/"/gi, ''))
    localStorage.setItem('roles', JSON.parse(grants).map(item => item.grantType).join(','))
  }
